import type { VersionInfo } from '@/features/version/types/version'

export const apiGetVersion = async (): Promise<VersionInfo> => {
  const response = await fetch('/version', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  })

  if (!response.ok) {
    throw new Error(`Request failed (${response.status})`)
  }

  return (await response.json()) as VersionInfo
}
